import axios from 'axios';
import { v2ApiErrorHandler } from '@/api/lib/error-handler';
import * as Api from './index';

export const listStudentUploads = async ({
    page = 1,
    page_size = 20,
    paginationUrl,
    schoolId,
    allSchools = false,
    ordering,
    search,
    errorHandlerOptions = {}
}) => {
    const url = paginationUrl || Api.getv2ApiBase(`/student-upload`);
    const defaultOptions = Api.getOptions();

    const params = {
        page,
        page_size,
        schoolId,
        allSchools,
        ordering,
        search
    };

    try {
        const response = await axios.get(url,
            {
                ...defaultOptions,
                params
            });

        return response.data;
    }
    catch (error) {
        return v2ApiErrorHandler({
            error,
            overrideMessage: 'Whoops. There was a problem loading the student uploads. Please try again.',
            ...errorHandlerOptions
        });
    }
};

// This function is used to get a signed URL for uploading a file to S3
export const getSignedUrlForStudentUpload = async ({
    schoolId,
    filename,
    contentType,
    title,
    uploadType,
    errorHandlerOptions = {}
}) => {
    const url = Api.getv2ApiBase(`/student-upload/${schoolId}/signed-url`);
    const defaultOptions = Api.getOptions();
    const payload = {
        filename,
        contentType,
        title,
        uploadType
    };

    try {
        const response = await axios.post(url, payload, defaultOptions);
        return response.data;
    }
    catch (error) {
        return v2ApiErrorHandler({
            error,
            overrideMessage: 'Whoops. There was a problem preparing the file upload. Please try again.',
            ...errorHandlerOptions
        });
    }
};

export const uploadFileToSignedUrl = async ({
    signedUrl,
    file,
    contentType,
    errorHandlerOptions = {}
}) => {
    try {
        const config = {
            headers: {
                'Content-Type': contentType
            }
        };

        return axios.put(signedUrl, file, config);
    }
    catch (error) {
        return v2ApiErrorHandler({
            error,
            overrideMessage: 'Whoops. There was a problem uploading the file. Please try again.',
            ...errorHandlerOptions
        });
    }
};

export const createStudentUpload = async ({
    filename,
    title,
    uploadType,
    notes,
    schoolId,
    status,
    errorHandlerOptions = {}
}) => {
    const url = Api.getv2ApiBase(`/student-upload/${schoolId}`);
    const defaultOptions = Api.getOptions();

    const payload = {
        filename,
        title,
        uploadType,
        notes,
        status
    };

    try {
        const response = await axios.post(url, payload, defaultOptions);
        return response.data;
    }
    catch (error) {
        return v2ApiErrorHandler({
            error,
            overrideMessage: 'Whoops. There was a problem creating the student upload. Please try again.',
            ...errorHandlerOptions
        });
    }
};

// This function is used to download a file from S3 using the signed URL
export const getStudentFileUrlForDownload = async ({
    id,
    schoolId,
    errorHandlerOptions = {}
}) => {
    const url = Api.getv2ApiBase(`/student-upload/${schoolId}/download/${id}`);
    const defaultOptions = Api.getOptions();

    try {
        const response = await axios.get(url, { ...defaultOptions });
        return response.data;
    }
    catch (error) {
        return v2ApiErrorHandler({
            error,
            overrideMessage: 'Whoops. There was a problem downloading the file. Please try again.',
            ...errorHandlerOptions
        });
    }
}
